<template>
  <Main>
    <v-container>
      <v-card class="mx-auto">
        <v-card-text>
          <p class="display-1 text--primary">
            Submit Target
            <v-btn small color="warning" @click="downloadTemplate()"
              >Download Excel Template</v-btn
            >
          </p>
          <div class="text--primary">
            <!-- {{ this.SELECTED_MONTH_PERIOD + " - " + this.SELECTED_YEAR_PERIOD + " - " + this.SELECTED_BRANCH}} -->
            <!-- {{ this.VSELECT_BRANCH }} -->
            <v-row>
              <v-col md="12" sm="12">
                <!-- {{ "CSV : " + this.JSON_FILE_UPLOAD }} -->

                <v-file-input
                  v-model="JSON_FILE_UPLOAD"
                  color="red darken-1"
                  counter
                  label="File input"
                  placeholder="Select your files"
                  prepend-icon="mdi-paperclip"
                  outlined
                  :show-size="1000"
                  @change="onAddFiles($event)"
                >
                  <template v-slot:selection="{ index, text }">
                    <v-chip
                      v-if="index < 2"
                      color="deep-purple accent-4"
                      dark
                      label
                      small
                    >
                      {{ text }}
                    </v-chip>

                    <span
                      v-else-if="index === 2"
                      class="overline grey--text text--darken-3 mx-2"
                    >
                      +{{ files.length - 2 }} File(s)
                    </span>
                  </template>
                </v-file-input>

                <!-- <FilePond
                  name="test"
                  ref="pond"
                  class-name="my-pond"
                  label-idle="Click or Drop files here..."
                  accepted-file-types="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/csv, application/csv"
                  :files="this.JSON_FILE_UPLOAD"
                  :init="handleFilePondInit"
                  v-on:updatefiles="handleFilePondUpdateFile"
                  v-on:removefile="handleFilePondRemoveFile"
                /> -->
              </v-col>
              <!-- <v-col md="12">
                <v-row>
                  <v-col md="12" justify="right">
                    <v-btn
                      class="mb-3 float-right"
                      small
                      color="warning"
                      @click="confirmModal(submitUpload)"
                      >Submit Data Target</v-btn
                    >
                  </v-col>
                  <v-col md="12">
                    <v-data-table></v-data-table>
                  </v-col>
                </v-row>
              </v-col> -->
            </v-row>
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mx-auto my-3">
        <v-card-text>
          <v-tabs
            color="white accent-4"
            fixed-tabs
            center
            background-color="indigo"
            dark
          >
            <v-tab>Error Data</v-tab>
            <v-tab>Clean Data</v-tab>

              <v-tab-item :key="1">
              <v-container fluid>
                <v-row>
                  <v-col class="py-0" md="9" sm="9">
                    <v-text-field
                      color="red darken-1"
                      v-model="searchErrorData"
                      append-icon="mdi-magnify"
                      label="Search Data"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col md="3" sm="3">
                    <v-btn
                      small
                      color="warning"
                      class="float-right"
                      style="width: 100%"
                      @click="downloadCSVError()"
                      >Export Error Mapping</v-btn
                    >
                  </v-col>
                  <v-col md="12" sm="12">
                    <v-data-table
                      :headers="dtHeaders"
                      :items="dtItemsFail"
                      :search="searchErrorData"
                      v-bind:allow-multiple="false"
                      :loading="dtLoading"
                      :item-class="itemRowValidation"
                      loading-text="Fetching Data..."
                    >
                      <template v-slot:item.VALUE_TGT_HO="{ item }">
                        {{ formatCurrency(item.VALUE_TGT_HO) }}
                      </template>

                       <template v-slot:item.VALUE_TGT_CAB="{ item }">
                        {{ formatCurrency(item.VALUE_TGT_CAB) }}
                      </template>

                      <template v-slot:item.VALUE_TGT_GROSS="{ item }">
                        {{ formatCurrency(item.VALUE_TGT_GROSS) }}
                      </template>

                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab-item :key="2">
              <v-container fluid>
                <v-row>
                  <v-col class="py-0" md="7" sm="7">
                    <v-text-field
                      color="red darken-1"
                      v-model="searchCleanData"
                      append-icon="mdi-magnify"
                      label="Search Data"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col md="5" sm="5">
                    <v-btn
                      small
                      color="warning"
                      class="float-right"
                      :disabled="disableSubmit"
                      @click="confirmModal(submitUpload)"
                      >Submit Uploaded File</v-btn
                    >
                    <v-btn
                      small
                      color="warning"
                      class="float-right mr-3"
                      @click="downloadCSVSuccess()"
                      >Export Clean Data</v-btn
                    >
                  </v-col>
                  <v-col md="12" sm="12">
                    <v-data-table
                      :headers="dtHeaders"
                      :items="dtItemsSuccess"
                      :search="searchCleanData"
                      v-bind:allow-multiple="false"
                      :loading="dtLoading"
                      :item-class="itemRowValidation"
                      loading-text="Fetching Data..."
                    >

                     <template v-slot:item.VALUE_TGT_HO="{ item }">
                        {{ formatCurrency(item.VALUE_TGT_HO) }}
                      </template>

                       <template v-slot:item.VALUE_TGT_CAB="{ item }">
                        {{ formatCurrency(item.VALUE_TGT_CAB) }}
                      </template>

                      <template v-slot:item.VALUE_TGT_GROSS="{ item }">
                        {{ formatCurrency(item.VALUE_TGT_GROSS) }}
                      </template>
                      
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline">Are you Sure to Continue ?</v-card-title>

        <v-card-text
          >It will submit all data which is imported to database. Please give
          confirmation before you submit.</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalConfirm = false"
            >Cancel</v-btn
          >

          <v-btn color="green darken-1" text @click="methodAction"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import XLSX from "xlsx";

// Import the plugin code
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

// Import Vue FilePond
import vueFilePond, { setOptions } from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType);

setOptions({
  allowMultiple: false,
});

const JSON_FOR_DOWNLOAD = [
  {
    YEAR_ID: "",
    MONTH_ID: "",
    KODE_CABANG: "",
    BISNIS: "",
    ITEM_SUBLINI: "",
    SUBLINI_PRODUCT: "",
    CHANNEL_OUTLET_GROUP: "",
    SALESPERSON_POSITION: "",
    TERITORY_GEO_GROUP: "",
    TARGET_REKOMENDASI_HO: "",
    TARGET_CABANG: "",
  },
];

export default {
  components: {
    Main,
    FilePond,
  },
  data() {
    return {
      searchCleanData: "",
      searchErrorData: "",
      methodAction: "",
      isOpenModalConfirm: false,
      JSON_FILE_UPLOAD: [],
      search: "",
      dtLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      isLoading: false,
      disableSubmit: true,
      dtHeaders: [
        {
          text: "MONTH",
          value: "TGT_MONTH_ID",
        },
        {
          text: "YEAR",
          value: "TGT_YEAR_ID",
        },
        {
          text: "KODE_CABANG",
          value: "BRANCH_CODE",
        },
        {
          text: "BISNIS",
          value: "BISNIS",
        },
        {
          text: "ITEM_SUBLINI",
          value: "LINI_ID",
        },
        {
          text: "SUBLINI_PRODUCT",
          value: "PRODUCT_SUB_LINE",
        },
        {
          text: "CHANNEL_OUTLET_GROUP",
          value: "OUTLET_CHANNEL_GROUP",
        },
        {
          text: "SALESPERSON_POSITION",
          value: "ROLE_POSITION_CODE",
        },
        {
          text: "TERITORY_GEO_GROUP",
          value: "TERITORY_GEO_GROUP",
        },
        {
          text: "TARGET_REKOMENDASI_HO",
          value: "VALUE_TGT_HO",
        },
        {
          text: "TARGET_CABANG",
          value: "VALUE_TGT_CAB",
        },
         {
          text: "TARGET_GROSS",
          value: "VALUE_TGT_GROSS",
        },
        {
          text: "REASON",
          value: "REASON",
        },
      ],
      dtItems: [],
      arrItems: [],
      dtItemsSuccess: [],
      dtItemsFail: [],
      dtItemsTemplate: [],
      previews: [],
      SELECTED_YEAR_PERIOD: "",
      SELECTED_MONTH_PERIOD: "",
      dtValidPeriod: ""
    };
  },
  mounted() {
    this.cekPeriod();
  },
  methods: {
    itemRowValidation: function (item) {
      return item.FLAG == "Y" ? "" : "not-valid";
    },
    confirmModal: function (method) {
      this.isOpenModalConfirm = true;
      this.methodAction = method;
    },

     formatCurrency(value) {
      if (isNaN(value)) return value; 
      return new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2,
      }).format(Number(value));
    },

    downloadTemplate() {
            const DATE_NOW = new Date();

            this.SELECTED_MONTH_PERIOD = DATE_NOW.getMonth()+1;
            this.SELECTED_YEAR_PERIOD = DATE_NOW.getFullYear();

            const USER_DATA = JSON.parse(localStorage.getItem("userData"));
            this.dtLoading = true;
            let data = {
                MonthID: this.SELECTED_MONTH_PERIOD,
                YearID: this.SELECTED_YEAR_PERIOD,
                BranchCode: USER_DATA.ORG_ID
            };
            this.$http
                .post("/target/getdataho",data, {
                  headers: {
                    "api-key": this.$apiKey
                  }
                })
                .then((res) => {
                  let data = res.data.data.DetailTarget;
                   data.forEach((val, index) => {
                                data[index].TARGET_REKOMENDASI_HO = parseInt(data[index].TARGET_REKOMENDASI_HO);
                                data[index].TARGET_CABANG = parseInt(data[index].TARGET_CABANG);
                            });
                  this.dtLoading = false;
                  //this.dtItemsTemplate = data;
                  const workBook = XLSX.utils.book_new(); // create a new blank book
                  const workSheet = XLSX.utils.json_to_sheet(data);//dtItemsTemplate
                   XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
                  XLSX.writeFile(workBook, "Template Target.xls");       
                })
                .catch((err) => {
                  this.dtLoading = false;
                  this.showSnackbar(err.toString());
                });
        },
    cekPeriod() {
            const userData = JSON.parse(localStorage.getItem("userData"));
              this.isLoading = true;
            let data = {
                typeID: 'TARGET',
                orgID :  userData.ORG_ID
            };
            this.$http
                .post("/setting/validPeriod", data, {
                  headers: {
                    "api-key": this.$apiKey
                  }
                })
                .then(res => {
                   this.isLoading = false;
                    const {
                        success,
                        message,
                        data
                    } = res.data;
                    this.dtValidPeriod = data.length;
                })
                .catch(err => {
                    this.isLoading = false;
                    this.showSnackbar(err.toString());
                });
        },
    onAddFiles(event) {
      if(this.dtValidPeriod>0){          
          try {
            this.isLoading = true;
            let self = this;
            let file = event;
            const userData = JSON.parse(localStorage.getItem("userData"));
            const reader = new FileReader();
            this.dtItems = [];
            this.arrItems = [];
            self.disableSubmit = false;

            reader.onload = (e) => {
              var data = new Uint8Array(e.target.result);
              var workbook = XLSX.read(data, {
                type: "array",
                cellDates: true,
              });

              let sheetName = workbook.SheetNames[0];
              /* DO SOMETHING WITH workbook HERE */
              let worksheet = workbook.Sheets[sheetName];
              const XLSXJSON = XLSX.utils.sheet_to_json(worksheet);
              console.log('XLSXJSON length ', XLSXJSON.length)
              for (let XLSXJSONDATA of XLSXJSON) {
                const {
                  MONTH_ID,
                  YEAR_ID,
                  KODE_CABANG,
                  BISNIS,
                  ITEM_SUBLINI,
                  SUBLINI_PRODUCT,
                  CHANNEL_OUTLET_GROUP,
                  SALESPERSON_POSITION,
                  TERITORY_GEO_GROUP,
                  TARGET_REKOMENDASI_HO,
                  TARGET_CABANG,
                } = XLSXJSONDATA;

                const newMappedData = {
                  MONTH_ID,
                  YEAR_ID,
                  KODE_CABANG,
                  BISNIS,
                  ITEM_SUBLINI,
                  SUBLINI_PRODUCT,
                  CHANNEL_OUTLET_GROUP,
                  SALESPERSON_POSITION,
                  TERITORY_GEO_GROUP,
                  TARGET_REKOMENDASI_HO: TARGET_REKOMENDASI_HO || 0,
                  TARGET_CABANG: TARGET_CABANG || 0,
                }

                if (
                  newMappedData.MONTH_ID != undefined &&
                  newMappedData.YEAR_ID != undefined &&
                  newMappedData.KODE_CABANG != undefined &&
                  newMappedData.BISNIS != undefined &&
                  newMappedData.ITEM_SUBLINI != undefined &&
                  newMappedData.SUBLINI_PRODUCT != undefined &&
                  newMappedData.CHANNEL_OUTLET_GROUP != undefined &&
                  newMappedData.SALESPERSON_POSITION != undefined &&
                  newMappedData.TERITORY_GEO_GROUP != undefined &&
                  newMappedData.TARGET_REKOMENDASI_HO != undefined &&
                  newMappedData.TARGET_CABANG != undefined
                ) {
                  
                  if (file.type == "application/vnd.ms-excel" || file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                    self.arrItems.push({
                      ...newMappedData,
                      USERIDUPDATE: userData.USER_ID,
                    });
                  }
                } else {
                  self.isLoading = false;
                  self.isOpenModalConfirm = false;
                  // Edited By Dedian 7 Okt 2021 //
                  self.showSnackbar(
                    "Periksa Kembali Template Atau Data Yang Digunakan"
                  );
                }
              }
              if (self.arrItems.length > 0) {
                  self.isOpenModalConfirm = false;
                  self.isLoading = true;
                  self.$http
                    .post("/target/uploadcab", {
                      excelData: self.arrItems,
                      orgID: userData.ORG_ID,
                    }, {
                      headers: {
                        "api-key": this.$apiKey
                      }
                    })
                    .then((res) => {
                      const { success, data, message } = res.data;
                      let valid = true;
                      let reason = "";
                      
                      if (success) {
                        self.isLoading = false;
                        self.dtItems = data;

                        self.dtItemsSuccess = data.success;
                        self.dtItemsFail = data.failed;  

                        if (data.success== null || data.success== "") {
                        } else {
                          //self.showSnackbar(data.success);
                          if(data.success.length > 0 && data.failed.length == 0){
                            if(data.success[0].RESULT != undefined){
                              self.showSnackbar(data.success[0].RESULT);
                            }else{
                              self.showSnackbar("Sukses upload");
                            }                      
                          }else{
                            //self.showSnackbar("Periksa Kembali Template Atau Data Yang Digunakan");
                          } 
                            
                        }
                        if (self.dtItemsFail.length > 0) {
                          self.disableSubmit = true;
                        }else{
                          self.disableSubmit = false;
                        }
                      } else {
                        self.isLoading = false;
                        //self.showSnackbar(message);
                        self.showSnackbar("Periksa Kembali Template Atau Data Yang Digunakan"); 
                      }
                    
                    })
                    .catch((err) => {
                      self.isLoading = false;
                      console.log(err.toString());
                    // self.showSnackbar(err.toString());
                    // self.showSnackbar("Value target tidak boleh kosong");     
                      self.showSnackbar("Periksa Kembali Template Atau Data Yang Digunakan");            
                    });
                  } else {
                    self.isLoading = false;
                    self.isOpenModalConfirm = false;
                    // Edited By Dedian 29 Juli 2021 //
                    self.showSnackbar(
                      "Periksa Kembali Template Atau Data Yang Digunakan"
                    );
                  }
                };

                if (file) {
                  reader.readAsArrayBuffer(file);
                }
              } 
          catch (e) {
            this.isLoading = false;
            this.isOpenModalConfirm = false;
            this.showSnackbar(e);
          }
      }else{
        this.showSnackbar(
          "Periode sudah ditutup."
        );
      }
    },
    submitUpload() {
      if ((this.dtItems.success[0].RESULT == undefined) && this.dtItems.failed.length == 0) {
        const USER_DATA = JSON.parse(localStorage.getItem("userData"));
         let data = {
          orgid: USER_DATA.ORG_ID,
        };

        this.isLoading = true;
        this.isOpenModalConfirm = false;

        this.$http
          .post("/target/submitcab", data, {
            headers: {
              "api-key": this.$apiKey
            }
          })
          .then((res) => {
            const { success, message, data } = res.data;
            if (success) {
              this.isLoading = false;
              this.dtItems = [];
              this.$router.push({
                path: `/target/overviewbranch`,
              });
            } else {
              this.isLoading = false;
              this.isOpenModalConfirm = false;
              this.showSnackbar(message);
            }
          })
          .catch((err) => {
            this.isLoading = false;
            this.isOpenModalConfirm = false;
            this.showSnackbar(err.toString());
          });
      } else {
        this.isLoading = false;
        this.isOpenModalConfirm = false;
        this.showSnackbar("Please Upload CSV File First !");
      }
    },
    downloadCSV() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(JSON_FOR_DOWNLOAD);//dtItemsTemplate
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Template Target.xls"); // initiate a file download in browser
    },
    downloadCSVError() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(this.dtItemsFail);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Error Data Assignment.xls"); // initiate a file download in browser
    },
    downloadCSVSuccess() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(this.dtItemsSuccess);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Valid Data Mapping Assignment.xls"); // initiate a file download in browser
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
